export default __webpack_public_path__ + "static/media/skydropx_logo.0c485a9e.svg";